import editRuleModule from './modules/edit_rule'
import listBusinessRulesModule from './modules/list_business_rules'
import listProductRecommendationModule from './modules/list_product_recommendation'
import editRecommendationModule from '@/store/modules/recommendations/modules/edit_recommendation'

const recommendationsModule = {
  namespaced: true,
  modules: {
    editRule: editRuleModule,
    listBusinessRules: listBusinessRulesModule,
    listProductRecommendation: listProductRecommendationModule,
    editRecommendation: editRecommendationModule
  }
}

export default recommendationsModule



// WEBPACK FOOTER //
// ./src/store/modules/recommendations/index.js